import { useEffect, useMemo } from 'react'

import { useWallet } from '@aptos-labs/wallet-adapter-react'
import { useDisclosure } from '@mantine/hooks'
import { CHAIN_ID, CHAIN_NAME } from 'config'

import { ButtonGradient } from 'components/ButtonGradient'
import CustomModal from 'components/CustomModal'
import { useCommonConnectStore } from 'components/WalletProvider/store.ts'

import s from './s.module.scss'

const InvalidNetworkModal = () => {
  const [openedModal, { close: closeModal, open: openModal }] = useDisclosure(false)
  const setConnectKey = useCommonConnectStore((state) => state.setConnectKey)
  const adapter = useWallet()

  const isPontemWidget = useMemo(
    () =>
      window.pontem?._client?._rpcClient?._options?.streamName === 'pontem-external' &&
      adapter?.wallet?.name === 'Pontem',
    [window.pontem, adapter?.wallet?.name],
  )

  const disconnect = () => {
    adapter?.disconnect()
    setConnectKey(null)

    closeModal()
  }

  const switchNetwork = async () => {
    window.pontem.switchNetwork(CHAIN_ID)

    const correctNetwork = await window.pontem.network()

    if (correctNetwork.chainId === CHAIN_ID) {
      closeModal()
    }
  }

  useEffect(() => {
    if (adapter.network && !adapter.network.name.includes(CHAIN_NAME)) {
      openModal()
    } else if (openedModal) {
      closeModal()
    }
  }, [adapter.network, closeModal, openModal, openedModal])

  return (
    <CustomModal
      classNames={{
        content: s.content,
        header: s.header,
        title: s.title,
      }}
      onClose={closeModal}
      opened={openedModal}
      title={`Change Network to Aptos ${CHAIN_NAME}`}
      withCloseButton={false}
    >
      <div className={s.wrapper}>
        <p>
          Right now we only support the {CHAIN_NAME} network of the Aptos blockchain. Please change it using your wallet
          and refresh page.
        </p>
        {isPontemWidget && (
          <ButtonGradient className={s.buttonNetWork} onClick={switchNetwork}>
            Switch Network
          </ButtonGradient>
        )}
        {!isPontemWidget && (
          <ButtonGradient className={s.buttonNetWork} onClick={disconnect}>
            Disconnect
          </ButtonGradient>
        )}
      </div>
    </CustomModal>
  )
}

export default InvalidNetworkModal
